import React from 'react';
import { Flex, Heading, Text, Button } from 'rebass';
import styled from 'styled-components';
import Steps, { Step } from 'rc-steps';

import ItemCollection from '../../components/icons/ItemCollection';
import { withRouter } from 'react-router';
import withSession from '../../lib/withSession';
import moment from 'moment';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

const GET_RECEIPT_URL = gql`
  query getReceiptFromOrder($orderId: String!) {
    getReceiptFromOrder(orderId: $orderId) {
      id
      url
    }
  }
`;

const DesktopOnly = styled.div`
  margin-bottom: 24px;
  @media screen and (max-width: 52em) {
    display: none;
    margin-bottom: 0;
  }
`;

const CustomStep = ({ status, current, ...props }) => {
  const type = current >= props.stepIndex ? 'process' : 'wait';
  return <Step status={type} {...props} />;
};

class LabDetailAwaitingRegistration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isJoting: false,
      enhancedPdf: null,
      isPdfEnhanced: false,
      labid: null,
      isRequestItemizedSentModalVisible: false,
      isRequestItemizedSent: false,
    };
  }

  scriptLoaded = () => {
    // console.log('Window', window);
  };

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = () => this.scriptLoaded();

    document.body.appendChild(script);
  }
  render() {
    const { labs, match, forceId, router, history } = this.props;

    if (!labs || !labs.length) {
      return null;
    }

    const lab = (labs || []).find((item) => {
      if (!!forceId) {
        return item.id === forceId;
      } else {
        return item.id === match.params.id;
      }
    });

    const currentStep = lab.status;

    let current = 0;
    if (currentStep) {
      if (currentStep === 'Your kit will be shipping soon.') {
        current = 0;
      } else if (currentStep === 'Your kit is on its way!') {
        current = 1;
      } else if (currentStep === 'Your kit has been delivered — time to register!') {
        current = 2;
      }
    }
    
    return (
      <Flex p={3} flexDirection="column">
        <Flex mb={3}>
          <ItemCollection width={90} />
          <Flex ml={3} flexDirection={'column'}>
            <Heading>Paloma Thyroid Test</Heading>
            <Text mt={2} style={{ fontWeight: 300, fontSize: '12px' }}>
              {!lab.orderDate ? '' : 'Ordered on ' + moment(lab.orderDate).format('MM/DD/YYYY')}
            </Text>
          </Flex>
        </Flex>

        <DesktopOnly mb={4}>
          <Steps current={current} labelPlacement="vertical">
            <CustomStep current={current} title="Your kit will be shipping soon" />
            <CustomStep current={current} title="Your kit is on its way!" />
            <CustomStep current={current} title="Your kit has been delivered — time to register!" />
          </Steps>
        </DesktopOnly>

        <Flex style={{ justifyContent: 'center', alignItems: 'center', gap: '16px' }}>
          <Flex flexDirection={'column'}>
            {!!lab.kitToCustomer && (
              <Button
                mt={4}
                variant={'pink'}
                onClick={() => {
                  window.open(lab.kitToCustomer, '_blank');
                }}
              >
                Track
              </Button>
            )}

            {!!lab.orderId && (
              <Query query={GET_RECEIPT_URL} variables={{ orderId: lab.orderId }}>
                {({ loading, data }) => {
                  // console.log({ data });
                  if (loading || !data || !data.getReceiptFromOrder || !data.getReceiptFromOrder.url) return null;

                  return (
                    <Button
                      mt={3}
                      variant={current === 2 ? 'pink' : 'primary'}
                      onClick={() => {
                        window.open(data.getReceiptFromOrder.url, '_blank');
                      }}
                    >
                      View Receipt
                    </Button>
                  );
                }}
              </Query>
            )}
            {current === 2 && (
              <Button
                variant="primary"
                mt={4}
                onClick={() => {
                  history.push('/register-kit');
                }}
              >
                Register My Kit
              </Button>
            )}
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export default withRouter(withSession(LabDetailAwaitingRegistration));
